import { LSKey } from '../constants/local-storage-keys'

class LocalStorageManager {
  set<T>(key: LSKey, value: T): void {
    localStorage.setItem(key, JSON.stringify(value))
  }

  get<T>(key: LSKey): T | undefined {
    const value = localStorage.getItem(key)
    if (value) {
      try {
        return JSON.parse(value) as T
      } catch (error) {
        console.error('Error parsing localStorage value', error)
        return undefined
      }
    }
    return undefined
  }

  remove(key: LSKey): void {
    localStorage.removeItem(key)
  }

  clear(): void {
    localStorage.clear()
  }
}

export const localStorageManager = new LocalStorageManager()
